export default __webpack_public_path__ + "static/media/Mickey-Mouse-Skeleton-Key-Double-Heart-Wrap-Bracelet.9bfa4973.jpg";